import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';

import { acceptInvitation, signIn } from 'api';
import { Logo, Container, Text, Box } from 'components';

class Signup extends Component {
  state = {
    form: {
      first_name: '',
      last_name: '',
      email: '',
      password: ''
    },
    prefilled: null,
    invitation_token: null,
    errors: {}
  };

  componentDidMount() {
    console.log("Document ready");
    this.setState({doneLoading: true});
  }

  onChange = e => {
    const { name, value } = e.target;
    const { form, errors } = this.state;
    this.setState({
      errors: { ...errors, [name]: false },
      form: { ...form, [name]: value }
    });
  };

  onSubmit = e => {
    e.preventDefault();
    this.setState({ errors: null });

    const valid = this.validateForm();

    if (valid) {
      const { invitation_token, form } = this.state;
      const { password, email } = form;

      // accept the invitation, then try to sign in
      acceptInvitation({ invitation_token, password })
        .then(res => {
          signIn({ email, password })
            .then(res => {
              this.props.history.push('/dashboard');
            })
            .catch(err => {
              this.props.history.push('/login');
            });
        })
        .catch(err => {
          this.setState({ errors: { token: true } });
        });
    }
  };

  validateForm = () => {
    const { form } = this.state;
    const fields = ['email', 'password', 'first_name', 'last_name'];
    let errors = {};

    fields.forEach(key => {
      const value = form[key];
      // Required
      if (value === '' || value === undefined) {
        errors[key] = { value, error: 'required' };
      }
    });

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  render() {
    return (
      <Fragment>
        <Box className="hero">
          <Container>
            <Box row py="4">
              <Logo white />
            </Box>
          </Container>
          <Container>
            <Box my="4">
              <Text display="h1">The CRNC Portal has changed!</Text>

              <Box my="5">
                {/* <Text display="h5">Log In, or Create an Account</Text> */}
                <Text display="p">We are excited to announce that Current is partnering with <a href="https://www.securitize.io/" target="_blank" rel="noopener noreferrer" style={{color: "white", textDecoration: "underline"}}>Securitize</a> to provide a compliant distribution experience.<br/> Our exchange partner and unlock date will be announced in the coming weeks.</Text>
                <Text display="p">Log in with your Securitize account to access your CRNC tokens.</Text>
              </Box>

              <div data-securitize-state="logged-out">
                <a data-securitize-action="login" href="/#" className="btn btn-secondary"style={{ width: 200 }}>
                  Log In
                </a>
              </div>

              <div data-securitize-state="logged-in">
                <a data-securitize-action="dashboard" href="/#" className="btn btn-secondary" style={{ width: 200 }}>
                  Dashboard
                </a>
                <br/>
                <a data-securitize-action="logout" href="/#" className="btn btn-primary" style={{ width: 200, marginTop: 15 }}>
                  Log Out
                </a>
              </div>

            </Box>
            <Box flex py="4">
              <Box mr="3" pr="3" border="right">
                <img
                  alt="secure"
                  className="mt-3"
                  src={require('../../images/hero-security.svg')}
                  width={19}
                  height={23}
                />
              </Box>
              <Text mb="0">
                Your details are secured by 256 bit encryption
                <br />
                and monitored 24/7
              </Text>
            </Box>
          </Container>
        </Box>
      </Fragment>
    );
  }
}

export default withRouter(Signup);
